module.exports = __webpack_public_path__ + "static/media/checkbox_icon.f7fe5340.png";